exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#preview[data-v-54921615]{background:#fff;position:relative;z-index:0}", ""]);

// exports
